import axios from "axios";
import {decodeJWT} from "../util/Util";
import {storageKeys} from "../util/storage";

/**
 * Logs a userId in
 * @param  {string}   email The name of the userId
 * @param  {string}   password The password of the userId
 * @return {Promise}
 */
export const login = (email, password) => new Promise((resolve, reject) => {
    // If there is a token in the localStorage, the userId already is authenticated
    if (loggedIn()) {
        return resolve(true);
    }
    axios.post('auth/login', {email, password})
        .then((response) => {
            // If the userId was authenticated successfully, save a random token to the localStorage
            if (response.data.token) {
                return resolve(extractTokenAndClaims(response.data));
            } else {
                // If there was a problem authenticating the userId, show an error on the form
                return reject(response.error);
            }
        })
        .catch(reject);
});

/**
 * Checks if anybody is logged in
 * @return {boolean} True if there is a logged in userId, false if there isn't
 */
export const loggedIn = () => {
    return !!localStorage[storageKeys.TOKEN] && localStorage[storageKeys.TOKEN] !== "undefined";
};

export const extractTokenAndClaims = data => {
    const token = data.token;
    const claims = decodeJWT(token);
    return {token, claims};
};



// WEBPACK FOOTER //
// ./src/js/auth/authentication.js